<template>
  <div class="result-summary-list text-s text-center text-gray-d  bg-white" v-if="place && radius">
    <div v-if="storesVisibleCount === 0" class="no-result-found px-4 pt-1 pb-4">
      <span class="mb-2">{{ text.noResultMessage }} {{ radius }} km {{ text.found }}</span>
      <span v-if="radius>50">{{ text.extendFailed }}</span>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
    data () {
        return {
            updatedRadius : 50,
            text: {
                extendFailed: Drupal.t('Unfortunately there is no Optiker Bode branch in the area you selected'),
                noResultMessage: Drupal.t('No Optiker Bode branch within a radius of'),
                found: Drupal.t('found'),
            }
        }
    },
    computed: {
        ...mapGetters('store', ['storesVisibleCount']),
        ...mapState([
            'loading'
        ]),
        ...mapState({
          place: state => state.map.place,
          radius: state => state.map.radius,
        })
    }
}
</script>

<style lang="scss" scoped>

</style>
